/* Pussy Liquor header: mobile menu toggle. Cart behaviour lives in pl-cart-drawer.js */
(function () {
  function setup(root) {
    var toggle = root.querySelector('[data-pl-menu-toggle]');
    if (!toggle || toggle.dataset.plReady) return;
    toggle.dataset.plReady = '1';
    var menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;

    function set(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      set(toggle.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        set(false);
        toggle.focus();
      }
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) set(false);
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', function (e) {
      if (e.matches) set(false);
    });
  }

  function init() {
    document.querySelectorAll('[data-pl-header]').forEach(setup);
  }

  init();
  /* Theme editor re-renders sections */
  document.addEventListener('shopify:section:load', init);
})();
